import { supabase } from '@/lib/supabase';

export type ManageProjectInvitationInput = {
  invitationToken: string;
  status: 'accepted' | 'declined';
};

export const manageProjectInvitation = async ({
  invitationToken,
  status,
}: ManageProjectInvitationInput) => {
  const { data, error } = await supabase.rpc('manage_project_invitation', {
    p_invitation_token: invitationToken,
    p_invitation_status: status,
  });

  if (error) {
    throw error;
  }

  return data;
};
